export {}

const init = () => {
  const INITIALIZED_CLASS = "--initialized"
  const faqs = document.querySelectorAll(`.i-faq:not(${INITIALIZED_CLASS})`)

  faqs.forEach((faq) => {
    const header = faq.querySelector(".i-faq__header")

    header?.addEventListener("click", () => {
      faq.classList.toggle("--open")
    })

    faq.classList.add(INITIALIZED_CLASS)
  })
}

init()
document.addEventListener("faqsReinit", init)
